// extracted by mini-css-extract-plugin
export default {"margin":"xQfSe9","center":"wmkiNd"};